import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { Feature } from 'ol';
import { CoordinatePointModel } from '../models/coordinate-point';
import { FilterModel } from '../models/filter';
import { CoordinatePointsService } from './coordinate-points.service'
import { ToolsControlService } from './tools-control.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoordinatePointsFilterService {

  active : boolean = false;
  fullScreenMode : boolean = false;
  filters: FilterModel[]  = [];
  windowOpened$ = new Subject<void>();

  constructor(private toolsService : ToolsControlService) {

     }
  initializeFilters(filters: FilterModel[]){
    this.filters  = cloneDeep(filters);
  }
  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.windowOpened$.next();
  }


}
